import request from '@/utils/request'
import store from '@/store'
const url = store.getters.getPostUrl;
export default {
  //获取右侧区域菜单列表
  getAreaNameList(param) {
    return request({
      url: url + '/area/getAreaByName',
      method: 'get',
      params: param
    })
  },
  getUserByName(userName) {
    var param = {
      fullName: userName,
    };
    return request({
      url: url + '/user/getUserByName',
      method: 'post',
      data: param
    })
  },
  getAllUserInfo(fullName) {
    console.log("fullName" + fullName);
    return request({
      url: url + '/user/getAllUserInfo?fullName=' + fullName,
      method: 'post'
    })
  },
  login(param) {
    return request({
      url: url + '/login',
      method: 'post',
      data: param
    })
  },
  logout(param) {
    return request({
      url: url + '/logout',
      method: 'post',
    })
  },
  getMenu() {
    return request({
      url: url + '/menu',
      method: 'get',
    })
  },
  getDict(dictName) {
    return request({
      url: url + '/business/dict/dictContentList',
      method: 'get',
      params: { name: dictName }
    })
  },

  getAreaList(param) {
    return request({
      url: url + '/area/list',
      method: 'get',
      params: param,
    })
  },
  //获取所有客户的市级名称和对应的areaCode
  getAllCustomerCityName(data) {
    return request({
      url: url + '/customer/getCustomerAreaByName',
      method: 'get',
      data:data
    })
  },

  getChooseCustomerCityName(data) {
    return request({
      url: url + '/userArea/getChooseUserArea',
      method: 'get',
      params: data
    })
  },
  getAlarmList(data) {
    return request({
      url: url + '/alarm/list',
      method: 'post',
      params: data
    })
  },
  delImg(param) {
	return request({
		url: url + '/customer/delImg',
		method: 'delete',
		params: {img: param}
	})
  },
  upload(data, id) {
  	return request({
  		config: {
  			'Content-Type': 'multipart/form-data',
  		},
  		url: url + '/customer/upload?id=' + id,
  		method: "post",
  		data: data
  	})
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/common/common.js